import { Component, forwardRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MessagesTemplatesService } from '../../services/messages-templates.service';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'message-templates',
  templateUrl: './message-templates.component.html',
  styleUrls: ['./message-templates.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MessageTemplatesComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MessageTemplatesComponent implements OnInit {
  templates: any[] = [];

  constructor(
    private readonly messagesTemplatesService: MessagesTemplatesService,
    private readonly matBottomSheetRef: MatBottomSheetRef,
  ) {}

  ngOnInit() {
    const element = document.getElementsByTagName('mat-bottom-sheet-container')[0];
    if (element) {
      element.classList.add('crm-scroll');
    }
    this.init();
  }

  private init() {
    this.messagesTemplatesService.get().subscribe({
      next: (res) => {
        this.templates = res;
      },
    });
  }

  close(template: any) {
    this.matBottomSheetRef.dismiss(template);
  }
}
